import React from 'react'

export default function Loading() {
  return (
    <div className='h-full w-full bg-green flex'>
        <h1 className='text-2xl m-auto text-white'>Loading...</h1>    
    </div>
  )
}
